<template>
  <div>
    <v-container fluid class="cta-container" :style="{ 'min-height': '800px' }">
      <v-container class="contain-width">

        <v-row>
          <v-col
              cols="12"
              md="8"
              offset-md="2"
              lg="6"
              offset-lg="3"
          >
            <h1 class="mt-6 mb-6">Our Story</h1>

            <div class="d-flex justify-center mb-6">
              <v-avatar size="200">
                <img
                    :src="require('@/assets/chris-headshot.jpg')"
                    alt="Chris"
                >
              </v-avatar>

              <v-list-item
                  color="rgba(0, 0, 0, .4)"
                  light
              >
                <v-list-item-content>
                  <v-list-item-title class="text-h6">
                    Chris Owen
                  </v-list-item-title>
                  <v-list-item-subtitle>Founder and Managing Director</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>


            <p>In the quest to solve a common problem faced by families and young children in schools, Chris Owen, the founder and Managing Director of Findmykit, embarked on a journey to revolutionize the lost property issue. It all began when his own children kept losing their school uniforms and equipment. While traditional name tags proved effective within the school premises, they fell short as the children grew older and their belongings started going missing outside of school boundaries.
            </p>

          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12"
              md="8"
              offset-md="2"
              lg="6"
              offset-lg="3"
          >
            <p><v-img :src="require('@/assets/fmk-stall.jpg')" width="40%" height="40%" class="float-left mr-6"></v-img>To address this challenge, Chris conceived the idea of the FMK smart tag. Drawing inspiration from the already proven concept of QR codes, he incorporated them into iron-on labels and stickers. Initially, if an item was scanned using a handheld scanner, Chris or his wife would be notified of any missing equipment. However, with advancements in mobile phone camera technology, the concept evolved further. Anyone could now scan a QR code and anonymously notify the account holder or item owner. To ensure privacy and security, certain filters were implemented in the interaction between finders and owners, adding an extra layer of protection.</p>
            <p>As Findmykit gained momentum, the company expanded its product range to cater to the evolving needs of its customers. This included the introduction of passport stickers, bag tags, and credit card-sized items that could easily fit into wallets or purses. With over a dozen individual products utilizing this innovative technology, Findmykit became a comprehensive solution for families, individuals, companies, and establishments facing the challenge of lost property.</p>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col
              cols="12"
              md="8"
              offset-md="2"
          >
            <blockquote>Lost property is not just about misplaced items; it's about lost time, money, and peace of mind.</blockquote>
          </v-col>
          <v-col
              cols="12"
              md="8"
              offset-md="2"
              lg="6"
              offset-lg="3"
          >
            <p>The company's growth didn't stop there. Findmykit made its mark in overseas territories, establishing itself as the only lost property system that enables instant and direct connection between finders and users anywhere in the world. As the travel industry improved post-COVID, Findmykit continued to innovate and introduce new items to cater to the changing landscape.</p>
            <p>Today, Findmykit stands as a testament to the vision and determination of its founder. With its cutting-edge technology and a wide range of products, the company strives to provide seamless and efficient solutions to the lost property problem, benefiting countless individuals and organizations worldwide.</p>

          </v-col>
        </v-row>
                <v-row class="mt-0">
                  <v-col
                      cols="12"
                      md="8"
                      offset-md="2"
                      lg="6"
                      offset-lg="3"
                  >
                    <v-img :src="require('@/assets/our-story.jpg')"></v-img>
                  </v-col>
                </v-row>
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>

<script>
import {mapState} from "vuex";
import Footer from './Footer.vue'
import {i18n} from "../i18n";
let logoNeotag = require('@/assets/neo-tag-logo-dark.png')

export default {
  name: "About",
  metaInfo () {
    return {
      title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Our story'),
      htmlAttrs: {
        lang: i18n.locale
      },
      meta: [
        { name: 'description', content: 'Our story' }
      ]
    }
  },
  components: {
    'Footer': Footer
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  computed: {
    ...mapState({
      brand: state => state.brand
    }),
    neotagLogo() {
      return logoNeotag
    },
    getBackground() {
      if (this.brand === 'neotag') {
        return require('@/assets/neotag-background.jpg')
      }
      else {
        return require('@/assets/neotag-background.jpg')
      }
    },
  }
}
</script>

<style scoped lang="scss">
blockquote {
  font-size: 2.5rem;
  line-height: 3rem;
  color: var(--v-primary-base);
  font-style: italic;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  text-indent: -0.45rem;
  quotes: "“" "”" "‘" "’";
  span {
    font-size: 4rem;
  }
}
@supports ( hanging-punctuation: first) {
  blockquote {
    text-indent: 0;
    hanging-punctuation: first;
  }
}

blockquote::before {
  content: open-quote;
}
blockquote::after {
  content: close-quote;
}
</style>
